import { modalAnim } from './utilities.js';

// jQuery Whaaaaaat?
import $ from 'jquery';
window.$ = window.jQuery = $;
console.log('jQuery loaded:', !!window.jQuery);

var doc = $( document );

doc.on('show.bs.modal', function (e) {
  var anim = 'zoomIn';
      modalAnim(anim);
})

doc.on('hide.bs.modal', function (e) {
  var anim = 'fadeOut';
      modalAnim(anim);
})

doc.on( 'click', '.duplicate-entry', function (e) {

  //return console.log("WOW");

  e.preventDefault();

  var data = {
    entryId: $(this).data('id'),
    authorId: $(this).data('author-id'),
    withCarryover: $(this).data('withCarryover')
  };

  // include csrf token
  var tokenName = window.csrfTokenName;
  data[ tokenName ] = window.csrfTokenValue;

  $.ajax( {
    type: "post",
    data: data,
    url: '/actions/tnt/scenarios/duplicate-entry',
    success: function ( response ) {
      //console.log(response)
      window.location.replace("/scenario/"+response);
    },
    error: function ( XMLHttpRequest, textStatus ) {

      console.log( "Status: " + textStatus );

    }
  } );

})

doc.on( 'change', '.country-select', function (e) {

  var country = $(this).val()

  // change the country specific content
  var url

  switch(country) {
    case 'us':
      url = "https://planthardiness.ars.usda.gov/";
      break;
    case 'canada':
      url = "http://planthardiness.gc.ca/?lang=en&m=24&s=p&speciesid=1000000&phz=phz1981-2010&bc=1";
      break;
    default:
  }

  $( "#whats-my-zone" ).attr( 'onClick', 'javascript: window.open("'+url+'", "_blank");' );

  // get the list of zones for this country

  var data = {
    country: country
  };

  var tokenName = window.csrfTokenName;
  data[ tokenName ] = window.csrfTokenValue;

  $.ajax( {
    type: "post",
    url: '',
    data: data,
    url: '/actions/tnt/scenarios/get-zones-by-country',
    success: function ( response ) {

      var zones = JSON.parse(JSON.stringify(response));

      /// populate the zones dropdown and reset it
      var options = "<option></option>";


      for ( var i = 0; i < zones.length; i ++ ) {
        var split = zones[i].title.split(" ")
        options += "<option value='"+split[1]+"' data-id='"+zones[i].id+"'>" + zones[i].title + "</option>";
      }

      $(this).find(".select2-container").remove()
      $('.zone-select').html(options).select2("val", "");

      $('#zone-help').fadeIn();

    },
    error: function ( XMLHttpRequest, textStatus ) {

      console.log( "Status: " + textStatus );

    }
  });

})

doc.on( 'change', '.units-select', function (e) {

  var system = $(this).val()

  // change the country specific content
  var targetUnits,
      coverageUnits

  switch(system) {
    case 'imperial':
      targetUnits = "lbs/1000 ft<sup>2</sup>";
      coverageUnits = "acres";
      break;
    case 'metric':
      targetUnits = "kg/100 m<sup>2</sup>";
      coverageUnits = "hectares";
      break;
    default:
  }

  $( "#target-units" ).html(targetUnits)
  $( "#coverage-units" ).html(coverageUnits)


  // get the list of target N for this system

  var data = {
    system: system
  };

  var tokenName = window.csrfTokenName;
  data[ tokenName ] = window.csrfTokenValue;

  $.ajax( {
    type: "post",
    url: '',
    data: data,
    url: '/actions/tnt/scenarios/get-targets-by-system',
    success: function ( response ) {

      var targets = JSON.parse(response);

      var options = "<option></option>";

      for ( var i = 0; i < targets.length; i ++ ) {
        options += "<option value='"+targets[i]+"'>" + targets[i] + "</option>";
      }

      $(this).find(".select2-container").remove()
      $('.target-select').html(options).select2("val", "");

    },
    error: function ( XMLHttpRequest, textStatus ) {

      console.log( "Status: " + textStatus );

    }
  });

})

doc.on( 'change', '.zone-select', function (e) {
	var zone = $(this).val()
	var zoneId = $('.zone-select option[value='+zone+']').data('id')
	$('input.zone').val(zoneId)
})

doc.on( 'change', '.spreaders-country-select', function (e) {

  var data = {
    country: $(this).val()
  };

  var tokenName = window.csrfTokenName;
  data[ tokenName ] = window.csrfTokenValue;

  $.ajax( {
    type: "post",
    url: '',
    data: data,
    url: '/actions/tnt/scenarios/get-products-by-country',
    success: function ( response ) {

      var products = JSON.parse(response);

      /// populate the zones dropdown and reset it
      var options = "<option></option>";

      for ( var i = 0; i < products.length; i ++ ) {
        options += "<option value='"+products[i].productCode+"'>"+products[i].title+"</option>"
      }

      $(this).find(".select2-container").remove()
      $('.spreader-product-select').html(options).select2("val", "");

    },
    error: function ( XMLHttpRequest, textStatus ) {

      console.log( "Status: " + textStatus );

    }
  });

})

doc.on( 'click', '.delete-entry', function (e) {

  e.preventDefault();

  var r = confirm("Are you sure you want to delete this?");

  if (r == true) {

    var el = $( this )
    //var row = this.parentElement

    var data = {
      entryId: el.data('id'),
      siteId: 1
    };

    // include csrf token
    var tokenName = window.csrfTokenName;
    data[ tokenName ] = window.csrfTokenValue;

    $.ajax({
        type: "post",
        data: data,
        url: '/actions/tnt/scenarios/delete-entry',
        success: function(data, response){
            var row = el.closest( "tr" )
            userScenariosTableDT.row( row ).remove().draw( false );
        }
    });

  }


})

doc.on( 'change', '#user-scenarios-table .show-pricing', function (e) {

  e.preventDefault();

  if ($(this).is(":checked")) {
    var showPricing = 1
  } else {
    var showPricing = 0
  }

  var data = {
    entryId: $(this).data('id'),
    showPricing: showPricing
  };

  // include csrf token
  var tokenName = window.csrfTokenName;
  data[ tokenName ] = window.csrfTokenValue;

  $.ajax( {
    type: "post",
    data: data,
    url: '/actions/tnt/scenarios/save-entry',
    success: function ( response ) {
      //console.log(response)
    },
    error: function ( XMLHttpRequest, textStatus ) {
      console.log( "Status: " + textStatus );
    }
  } );

})






